/* Progressive enhancements only: product forms and navigation remain native Shopify. */
(() => {
  'use strict';
  if (window.__avrEnhancementsReady) return;
  window.__avrEnhancementsReady = true;
  if (!customElements.get('averelle-gift-finder')) {
    customElements.define('averelle-gift-finder', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this.onReady = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this.onReady, {once: true});
        } else {
          this.initialize();
        }
      }
      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.controls = this.querySelector('[data-avr-filters]');
        this.cards = [...this.querySelectorAll('[data-avr-gift]')];
        this.output = this.querySelector('[data-avr-count]');
        this.empty = this.querySelector('[data-avr-empty]');
        if (!this.controls) {
          if (!this.observer) {
            this.observer = new MutationObserver(() => this.initialize());
            this.observer.observe(this, {childList: true, subtree: true});
          }
          return;
        }
        this.observer?.disconnect();
        this.observer = null;
        this.initialized = true;
        this.controls.hidden = false;
        this.onChange = () => this.filter();
        this.onReset = () => {
          this.controls.querySelectorAll('select').forEach(select => { select.value = ''; });
          this.filter();
        };
        this.controls.addEventListener('change', this.onChange);
        this.reset = this.querySelector('[data-avr-reset]');
        this.reset?.addEventListener('click', this.onReset);
        this.filter();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
        this.observer?.disconnect();
        this.observer = null;
        this.controls?.removeEventListener('change', this.onChange);
        this.reset?.removeEventListener('click', this.onReset);
        this.initialized = false;
      }
      filter() {
        const value = key => this.controls.querySelector(`[data-avr-filter="${key}"]`)?.value || '';
        const budget = value('budget');
        const colour = value('colour');
        const category = value('category');
        let visible = 0;
        this.cards.forEach(card => {
          const price = Number(card.dataset.price);
          const match = (!budget || (Number.isFinite(price) && price <= Number(budget))) &&
            (!colour || card.dataset.colour === colour) &&
            (!category || card.dataset.category === category);
          card.hidden = !match;
          if (match) visible += 1;
        });
        if (this.output && this.dataset.matchingLabel) {
          this.output.textContent = `${visible} ${this.dataset.matchingLabel}`;
        }
        if (this.empty) this.empty.hidden = visible !== 0;
      }
    });
  }
  const revealAnchor = () => {
    if (!window.location.hash) return;
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
    let target = document.getElementById(id);
    while (target) {
      if (target.tagName === 'DETAILS') target.open = true;
      target = target.parentElement;
    }
  };
  window.addEventListener('hashchange', revealAnchor);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealAnchor, {once: true});
  } else {
    revealAnchor();
  }
  if (!customElements.get('averelle-delivery-estimate')) {
    customElements.define('averelle-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        const target = this.querySelector('[data-avr-delivery-range]');
        if (!target) return;
        const minDays = Number.parseInt(this.dataset.minDays || '2', 10);
        const maxDays = Number.parseInt(this.dataset.maxDays || '3', 10);
        const localeMap = {de: 'de-DE', en: 'en-GB', fr: 'fr-FR', es: 'es-ES', it: 'it-IT'};
        const requestedLanguage = (this.dataset.language || document.documentElement.lang || 'de').slice(0, 2);
        const language = Object.prototype.hasOwnProperty.call(localeMap, requestedLanguage) ? requestedLanguage : 'de';
        const addBusinessDays = (date, amount) => {
          const result = new Date(date);
          result.setHours(12, 0, 0, 0);
          let added = 0;
          while (added < amount) {
            result.setDate(result.getDate() + 1);
            const weekday = result.getDay();
            if (weekday !== 0 && weekday !== 6) added += 1;
          }
          return result;
        };
        const now = new Date();
        now.setHours(12, 0, 0, 0);
        const earliest = addBusinessDays(now, minDays);
        const latest = addBusinessDays(now, maxDays);
        if (language === 'de') {
          const weekday = new Intl.DateTimeFormat('de-DE', {weekday: 'long'});
          const date = new Intl.DateTimeFormat('de-DE', {day: 'numeric', month: 'long'});
          target.textContent = weekday.format(earliest) + ', den ' + date.format(earliest) + ' – ' + weekday.format(latest) + ', den ' + date.format(latest);
        } else {
          const formatter = new Intl.DateTimeFormat(localeMap[language], {weekday: 'short', day: 'numeric', month: 'short'});
          target.textContent = formatter.format(earliest) + ' – ' + formatter.format(latest);
        }
      }
    });
  }
})();



